import axios from "axios";
import io from "socket.io-client";

export const api = process.env.REACT_APP_API_URL;
export const zipApi = "https://zip.pacs.corridor.vet/";

let token = localStorage.getItem("token");
let subs = {};
export let socket;

let setAuthenticated = () => {};
let pushAlert, socketStatus

initSocket();
export function setAuthenticatedCallback(callback) {
  setAuthenticated = callback;
}
export function setPushAlert(callback) {
  pushAlert = callback;
}
export function onSocketStatus(callback) {
  socketStatus = callback;
}

const handleVisibilityChange = () => {
  if (document.visibilityState === 'hidden')
    closeSocket()
  else if (document.visibilityState === 'visible')
    initSocket()
}
document.addEventListener('visibilitychange', handleVisibilityChange)

export async function apiFetch(params) {
  console.log("API call: " + params.endpoint);
  return axios({
    url: `${api}${params.endpoint}`,
    method: params.method || "GET",
    headers: Object.assign(
      {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      token ? { Authorization: `Bearer ${token}` } : null,
      params.headers
    ),
    data: params.data,
    params: params.params,
    signal: params.abortSignal,
    responseType: params.responseType || 'json',
    retries: params.retries || 3
  }).catch(e => {
    if (e.response && e.response.status === 403)
      // Forbidden - Log user out
      Logout()
    else throw e
  });
}

const dataPromise = async (p, n) => new Promise((resolve, reject) =>
  p.then(r => (r && typeof r.data !== 'undefined' && resolve(r.data)) || reject(r)).catch(e => reject(e))
).catch(e => {
  if (!n && pushAlert) {
    //const message = e.response?.data?.errors || (['ERR_NETWORK'].includes(e.code) && e.message) || undefined
    const message = e.response?.data?.errors || undefined
    if (message) {
      pushAlert({severity: 'error', message, timestamp: new Date()})
      window.scrollTo(0, 0)
    }
  }
  throw e
})

async function initSocket() {
  await closeSocket()
  if (token) {
    socket = io(api, { auth: { token: token }, transports: ['websocket'] })
    socket.on('connect', () => socketStatus && socketStatus(true))
    socket.on('disconnect', () => socketStatus && socketStatus(false))
    
    // Global video call listener
    socket.on('video_call_ring', (data) => {
      // Let React components handle it
    });
    
    socket.on("sub", (data) => {
      const mcb = (d) => console.log("Missing callback for subscription", d);
      if (data.coll in subs)
        if ("type" in data && data.type in subs[data.coll])
          if ("id" in data && data.id in subs[data.coll][data.type])
            if ("sub" in subs[data.coll][data.type][data.id])
              subs[data.coll][data.type][data.id].sub(data);
            else mcb(data);
          else if ("sub" in subs[data.coll][data.type])
            subs[data.coll][data.type].sub(data);
          else mcb(data);
        else if ("sub" in subs[data.coll]) subs[data.coll].sub(data);
        else mcb(data);
    })
  }
}
async function closeSocket() {
  if (socket) socket.disconnect();
}

export async function Subscribe(e, callBack) {
  if ("coll" in e) {
    if (!(e.coll in subs)) subs[e.coll] = {};
    if ("type" in e && !(e.type in subs[e.coll])) subs[e.coll][e.type] = {};
    if ("id" in e && !(e.id in subs[e.coll][e.type]))
      subs[e.coll][e.type][e.id] = {};

    socket.emit("sub", e);
    if ("type" in e)
      if ("id" in e) subs[e.coll][e.type][e.id].sub = callBack;
      else subs[e.coll][e.type].sub = callBack;
    else subs[e.coll].sub = callBack;

    console.log("Subscribe call:", e);
  }
}

export async function Unsubscribe(e, id) {
  if ("coll" in e) {
    socket.emit("unsub", e);
    if ("type" in e)
      if ("id" in e) delete subs[e.coll][e.type][e.id].sub;
      else delete subs[e.coll][e.type].sub;
    else delete subs[e.coll].sub;
    console.log("Unsubscribe call:", e);
  }
}

export async function Login(email, password) {
  await Logout()
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "auth",
      data: { email: email, password: password },
    })
  ).then(response => {
    if (response.accessToken && response.refreshToken) {
      localStorage.setItem("token", (token = response.accessToken))
      initSocket()
    } else throw new Error("Unknown error")
  })
}

export async function CreateAccount(data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "users",
      data
    })
  ).then(response => {
    if (response.id) localStorage.setItem("token", (token = response.id))
    else throw new Error("Unknown error")
  })
}

export async function Logout() {
  localStorage.removeItem("token")
  token = undefined
  setAuthenticated(false)
  await closeSocket()
}
export function CheckLogin() {
  return !!token;
}
export async function VerifyUser(email, code) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "users/verify",
      data: { email: email, code: code },
    })
  )
}
export async function ForgotPassword(email) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "users/forgot",
      data: { email: email },
    })
  )
}
export async function ResetPassword(data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "users/reset",
      data,
    })
  )
}
export async function VerifyResend(email) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "users/verify/resend",
      data: { email: email },
    })
  )
}
export async function AcceptTerms(email) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "users/accept-terms",
      data: { email: email },
    })
  )
}
export async function GetUser(userId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "users" + (userId ? "/" + userId : ""),
    })
  )
}
export async function NewStudy(data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "studies",
      data,
    })
  )
}
export async function UpdateUser(userId, data) {
  return dataPromise(
    apiFetch({
      method: "PATCH",
      endpoint: "users" + (userId ? "/" + userId : ""),
      data,
    })
  )
}
export async function GetStudy(studyId, params, abortSignal) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "studies" + (studyId ? "/" + studyId : ""),
      params,
      abortSignal
    })
  )
}
export async function GetStudyCount(params, abortSignal) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "studies/count",
      params,
      abortSignal
    })
  , true)
}
export async function ClaimStudy(studyId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "studies/" + studyId + "/claim",
    })
  )
}
export async function UnClaimStudy(studyId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "studies/" + studyId + "/unclaim",
    })
  )
}
export async function UnRequestStudy(studyId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "studies/" + studyId + "/unrequest",
    })
  )
}
export async function UploadInstance(files, params, callBack) {
  let resp = [];
  // Send one-by-one since server is keeping them in memory to offload to DICOM server
  for (const file of files) {
    let fd = new FormData();
    fd.append("file", file);
    // await, don't overload server
    await dataPromise(
      apiFetch({
        method: "POST",
        endpoint: "instances",
        data: fd,
        headers: { "Content-Type": "multipart/form-data" },
        params
      })
    ).then(response => {
      resp.push(response)
      if (callBack) callBack(file, response)
    })
  }
  return new Promise((r,j) => r(resp))
}
export async function UpdateStudyTags(studyId, data) {
  return dataPromise(
    apiFetch({
      method: "PATCH",
      endpoint: "studies/" + studyId + "/tags",
      data
    })
  )
}
export async function UpdateStudy(studyId, data) {
  return dataPromise(
    apiFetch({
      method: "PATCH",
      endpoint: "studies" + (studyId ? "/" + studyId : ""),
      data,
    })
  )
}
export async function GetOrg(orgId, params) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "orgs" + (orgId ? "/" + orgId : ""),
      params,
    })
  )
}
export async function GetOrgChildren(orgId, params) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "orgs/" + orgId + "/children",
      params,
    })
  )
}
export async function GetOrgUsers(orgId, params) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "orgs/" + orgId + "/users",
      params,
    })
  )
}
export async function GetOrgConsultUsers(orgId, params) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "orgs/" + orgId + "/users/consult",
      params,
    })
  )
}
export async function UpdateConsult(studyId, data) {
  return dataPromise(
    apiFetch({
      method: "PATCH",
      endpoint: "studies/" + studyId + "/consult",
      data
    })
  )
}
export async function GetAWSCredentials() {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "aws/credentials",
    })
  )
}

export async function UpdateReport(studyId, data) {
  return dataPromise(
    apiFetch({
      method: "PATCH",
      endpoint: "studies/" + studyId + "/report",
      data,
    })
  )
}
export async function GetReport(studyId, filename) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint:
        "studies/" + studyId + "/report/" + (filename ? filename + ".pdf" : ""),
    })
  )
}
export async function GetReportHtml(studyId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint:
        "studies/" + studyId + "/report/html",
    })
  )
}
export async function UploadReportImage(files, callBack) {
  let resp = [];
  for (const file of files) {
    let fd = new FormData();
    fd.append("file", file);
    await dataPromise(
      apiFetch({
        method: "POST",
        endpoint: "studies/report/image",
        data: fd,
        headers: { "Content-Type": "multipart/form-data" },
      })
    ).then(reponse => {
      resp.push(reponse)
      if (callBack) callBack(file, reponse)
    })
  }
  return new Promise((r,j) => r(resp))
}
export async function UploadReportFile(files, callBack) {
  let resp = [];
  // Send one-by-one since server is keeping them in memory to offload to DICOM server
  for (const file of files) {
    let fd = new FormData();
    fd.append("file", file);
    await dataPromise(
      apiFetch({
        method: "POST",
        endpoint: "studies/report",
        data: fd,
        headers: { "Content-Type": "multipart/form-data" },
      })
    ).then(reponse => {
      resp.push(reponse)
      if (callBack) callBack(file, reponse)
    })
  }
  return new Promise((r,j) => r(resp))
}
export async function SendStudy(studyId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "studies/" + studyId + "/send",
    })
  )
}
export async function SendMobile(studyId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "studies/" + studyId + "/mobile",
    })
  )
}
export async function CompleteStudy(studyId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "studies/" + studyId + "/complete",
    })
  )
}
export async function DeleteStudy(studyId) {
  return dataPromise(
    apiFetch({
      method: "DELETE",
      endpoint: "studies/" + studyId,
    })
  )
}
export async function ClearStudy(studyId) {
  return dataPromise(
    apiFetch({
      method: "DELETE",
      endpoint: "studies/" + studyId + "/clear",
    })
  )
}
export async function GetStudyJson(studyId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "studies/" + studyId + "/json",
    })
  )
}
export async function UpdateAddendum(studyId, data) {
  return dataPromise(
    apiFetch({
      method: "PATCH",
      endpoint: "studies/" + studyId + "/addendum",
      data,
    })
  )
}
export async function ReOrg(studyId, data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "studies/" + studyId + "/reorg",
      data,
    })
  )
}
export async function SendReport(studyId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "studies/" + studyId + "/report/send"
    })
  )
}
export async function SendPackage(studyId, data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "studies/" + studyId + "/package/send",
      data
    })
  )
}
export async function GetToken(data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "auth/token",
      data
    })
  )
}
export async function GetInstanceThumb(instanceId) {
  return new Promise (res => {
    apiFetch({
      method: "GET",
      endpoint: "instances/" + instanceId + "/thumb",
      headers: {
        Accept: 'image/*'
      },
      responseType: 'blob'
    }).then(response => {
      const reader = new FileReader();
      reader.onloadend = res
      reader.readAsDataURL(response.data);
    }).catch(e => e)
  }).then(r => r.target?.result)
}
export async function GetSeriesBatch(ids) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "series/batch",
      data: { ids }
    })
  )
}
export async function fetchDicom(uri, studyDesc) {
  return fetch(uri).then(r=>(r.ok && r) || pushAlert({severity: 'error', message: 'Failed to get DICOM in '+studyDesc, timestamp: new Date()}))
}
export async function MergeStudies(studyId, data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "studies/" + studyId + "/merge",
      data
    })
  )
}
export async function DuplicateStudy(studyId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "studies/" + studyId + "/duplicate"
    })
  )
}
export async function AssignStudy(studyId, data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "studies/" + studyId + "/requestee",
      data
    })
  )
}
export async function CreateOrg(data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "orgs",
      data
    })
  )
}
export async function UpdateOrg(orgId, data) {
  return dataPromise(
    apiFetch({
      method: "PATCH",
      endpoint: "orgs" + (orgId ? "/" + orgId : ""),
      data,
    })
  )
}
export async function UpdateOrgSettings(orgId, data) {
  return dataPromise(
    apiFetch({
      method: "PATCH",
      endpoint: `orgs/${orgId}/settings`,
      data,
    })
  )
}
export async function DeleteOrg(orgId) {
  return dataPromise(
    apiFetch({
      method: "DELETE",
      endpoint: "orgs/" + orgId,
    })
  )
}
export async function AssignUser(orgId, data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "orgs/" + orgId + "/assign",
      data,
    })
  )
}
export async function UnassignUser(orgId, data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "orgs/" + orgId + "/unassign",
      data,
    })
  )
}
export async function GrantUser(orgId, data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "orgs/" + orgId + "/grant",
      data,
    })
  )
}
export async function CopyUsers(orgId, data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "orgs/" + orgId + "/copy",
      data,
    })
  )
}
export async function RemoveBilling(orgId, billingId) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "orgs/" + orgId + "/billing/remove",
      data: {billingId},
    })
  )
}
export async function AddBilling(orgId, billingCode) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "orgs/" + orgId + "/billing/add",
      data: {billingCode},
    })
  )
}
export async function UpdateBillingOrder(orgId, billingIds) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "orgs/" + orgId + "/billing/order",
      data: {billingIds},
    })
  )
}

// Billing Manager API
export async function GetBillingGroups(orgId) {
  return dataPromise(apiFetch({ method: "GET", endpoint: "billing-manager/" + orgId + "/groups" }))
}
export async function CreateBillingGroup(orgId, name) {
  return dataPromise(apiFetch({ method: "POST", endpoint: "billing-manager/" + orgId + "/groups", data: { name } }))
}
export async function UpdateBillingGroup(groupId, name) {
  return dataPromise(apiFetch({ method: "PATCH", endpoint: "billing-manager/groups/" + groupId, data: { name } }))
}
export async function DeleteBillingGroup(groupId) {
  return dataPromise(apiFetch({ method: "DELETE", endpoint: "billing-manager/groups/" + groupId }))
}
export async function CreateBillingCode(orgId, name) {
  return dataPromise(apiFetch({ method: "POST", endpoint: "billing-manager/" + orgId + "/codes", data: { name } }))
}
export async function DeleteBillingCode(orgId, billingId) {
  return dataPromise(apiFetch({ method: "DELETE", endpoint: "billing-manager/" + orgId + "/codes/" + billingId }))
}
export async function GetBillingPricing(orgId) {
  return dataPromise(apiFetch({ method: "GET", endpoint: "billing-manager/" + orgId + "/pricing" }))
}
export async function CreateBillingPricing(orgId, data) {
  return dataPromise(apiFetch({ method: "POST", endpoint: "billing-manager/" + orgId + "/pricing", data }))
}
export async function DeleteBillingPricing(pricingId) {
  return dataPromise(apiFetch({ method: "DELETE", endpoint: "billing-manager/pricing/" + pricingId }))
}
export async function GetOrgBilling(orgId) {
  return dataPromise(apiFetch({ method: "GET", endpoint: "billing-manager/" + orgId + "/org-billing" }))
}
export async function UpdateOrgBillingOrder(orgId, billingIds) {
  return dataPromise(apiFetch({ method: "POST", endpoint: "billing-manager/" + orgId + "/org-billing/order", data: { billingIds } }))
}
export async function GetPriorities(orgId) {
  return dataPromise(apiFetch({ method: "GET", endpoint: "billing-manager/" + orgId + "/priorities" }))
}
export async function CreatePriority(orgId, data) {
  return dataPromise(apiFetch({ method: "POST", endpoint: "billing-manager/" + orgId + "/priorities", data }))
}
export async function UpdatePriority(priorityId, data) {
  return dataPromise(apiFetch({ method: "PATCH", endpoint: "billing-manager/priorities/" + priorityId, data }))
}
export async function DeletePriority(priorityId) {
  return dataPromise(apiFetch({ method: "DELETE", endpoint: "billing-manager/priorities/" + priorityId }))
}
export async function ReorderPriorities(orgId, ids) {
  return dataPromise(apiFetch({ method: "POST", endpoint: "billing-manager/" + orgId + "/priorities/order", data: { ids } }))
}
export async function GetResolvedPricing(orgId, clinicOrgId) {
  return dataPromise(apiFetch({ method: "GET", endpoint: "billing-manager/" + orgId + "/resolved-pricing", params: { clinicOrgId } }))
}
export async function GetPriorityPricing(orgId) {
  return dataPromise(apiFetch({ method: "GET", endpoint: "billing-manager/" + orgId + "/priority-pricing" }))
}
export async function CreatePriorityPricing(orgId, data) {
  return dataPromise(apiFetch({ method: "POST", endpoint: "billing-manager/" + orgId + "/priority-pricing", data }))
}
export async function DeletePriorityPricing(pricingId) {
  return dataPromise(apiFetch({ method: "DELETE", endpoint: "billing-manager/priority-pricing/" + pricingId }))
}
export async function GetOrgTags(orgId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: `orgs/${orgId}/tags`
    })
  )
}
export async function UpdateIssuer(orgId, issuerAet) {
  return dataPromise(
    apiFetch({
      method: "PATCH",
      endpoint: "orgs/" + orgId + "/issueraet",
      data: {issuerAet},
    })
  )
}
export async function PingModality(data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "modalities/ping",
      data,
    })
  )
}
export async function DicomSend(studyId, data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "studies/" + studyId + "/send",
      data
    })
  )
}
export async function BillingReport(data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "reports/billing",
      responseType: 'blob',
      data
    })
  )
}
export async function StudyReport(data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "reports/studies",
      responseType: 'blob',
      data
    })
  )
}
export async function MwlEdit(studyId, data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "studies/" + studyId + "/mwl",
      data
    })
  )
}
export async function GetMwl(studyId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "studies/" + studyId + "/mwl"
    })
  )
}

// Notification Rules API
export async function GetNotificationRules(orgId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "notification-rules",
      params: orgId ? { org: orgId } : undefined
    })
  )
}
export async function CreateNotificationRule(data) {
  return dataPromise(
    apiFetch({
      method: "POST",
      endpoint: "notification-rules",
      data
    })
  )
}
export async function UpdateNotificationRule(ruleId, data) {
  return dataPromise(
    apiFetch({
      method: "PATCH",
      endpoint: "notification-rules/" + ruleId,
      data
    })
  )
}
export async function DeleteNotificationRule(ruleId) {
  return dataPromise(
    apiFetch({
      method: "DELETE",
      endpoint: "notification-rules/" + ruleId
    })
  )
}
// Scheduler API
export async function GetSchedule(orgId, start, end, { childOrg, filterOrg } = {}) {
  return dataPromise(
    apiFetch({ method: "GET", endpoint: "scheduler/" + orgId, params: { start, end, childOrg, filterOrg } })
  )
}
export async function GetUnscheduledStudies(orgId, type = 'mobile') {
  return dataPromise(
    apiFetch({ method: "GET", endpoint: "studies", params: { view: 'scheduler', org: orgId, type } })
  )
}
export async function HasSchedule(orgId) {
  return dataPromise(
    apiFetch({ method: "GET", endpoint: "scheduler/" + orgId + "/has" })
  )
}
export async function GetScheduleTemplates(orgId) {
  return dataPromise(
    apiFetch({ method: "GET", endpoint: "scheduler/" + orgId + "/templates" })
  )
}
export async function CreateScheduleTemplate(orgId, data) {
  return dataPromise(
    apiFetch({ method: "POST", endpoint: "scheduler/" + orgId + "/templates", data })
  )
}
export async function UpdateScheduleTemplate(orgId, data) {
  return dataPromise(
    apiFetch({ method: "PATCH", endpoint: "scheduler/" + orgId + "/templates", data })
  )
}
export async function RemoveScheduleTemplate(orgId, data) {
  return dataPromise(
    apiFetch({ method: "POST", endpoint: "scheduler/" + orgId + "/templates/remove", data })
  )
}
export async function UpsertScheduleOverride(orgId, data) {
  return dataPromise(
    apiFetch({ method: "PUT", endpoint: "scheduler/" + orgId + "/overrides", data })
  )
}
export async function RemoveScheduleOverride(orgId, date, templateId) {
  return dataPromise(
    apiFetch({ method: "POST", endpoint: "scheduler/" + orgId + "/overrides/remove", data: { date, templateId } })
  )
}
export async function RemoveSlotFromOverride(orgId, slotId) {
  return dataPromise(
    apiFetch({ method: "POST", endpoint: "scheduler/" + orgId + "/overrides/remove-slot", data: { slotId } })
  )
}
export async function MoveSlot(orgId, data) {
  return dataPromise(
    apiFetch({ method: "POST", endpoint: "scheduler/" + orgId + "/slots/move", data })
  )
}
export async function UpdateSlot(orgId, data) {
  return dataPromise(
    apiFetch({ method: "POST", endpoint: "scheduler/" + orgId + "/slots/update", data })
  )
}
export async function GetAvailableSlots(orgId, date) {
  return dataPromise(
    apiFetch({ method: "GET", endpoint: "scheduler/" + orgId + "/slots", params: { date } })
  )
}
export async function GetNextSlotDate(orgId, filterChildOrg) {
  const params = filterChildOrg ? { filterChildOrg } : {}
  return dataPromise(
    apiFetch({ method: "GET", endpoint: "scheduler/" + orgId + "/slots/next", params })
  )
}
export async function UpdateOrgSlotColor(orgId, color) {
  return dataPromise(
    apiFetch({ method: "PATCH", endpoint: `orgs/${orgId}/slot-color`, data: { color } })
  )
}
export async function BookSlot(data) {
  return dataPromise(
    apiFetch({ method: "POST", endpoint: "scheduler/slots/book", data })
  )
}
export async function UnbookSlot(data) {
  return dataPromise(
    apiFetch({ method: "POST", endpoint: "scheduler/slots/unbook", data })
  )
}
export async function ReorderCases(data) {
  return dataPromise(
    apiFetch({ method: "POST", endpoint: "scheduler/slots/reorder", data })
  )
}

// Modality Scheduler API
export async function GetModalitySchedule(orgId, date) {
  return dataPromise(
    apiFetch({ method: "GET", endpoint: `modality-scheduler/${orgId}`, params: { date } })
  )
}
export async function BookModalitySlot(orgId, data) {
  return dataPromise(
    apiFetch({ method: "POST", endpoint: `modality-scheduler/${orgId}/book`, data })
  )
}
export async function UnbookModalitySlot(orgId, data) {
  return dataPromise(
    apiFetch({ method: "POST", endpoint: `modality-scheduler/${orgId}/unbook`, data })
  )
}
export async function UpdateModalitySlot(orgId, data) {
  return dataPromise(
    apiFetch({ method: "PATCH", endpoint: `modality-scheduler/${orgId}/slot`, data })
  )
}
export async function GetModalityLimitTemplates(orgId) {
  return dataPromise(
    apiFetch({ method: "GET", endpoint: `modality-scheduler/${orgId}/limits/templates` })
  )
}
export async function CreateModalityLimitTemplate(orgId, data) {
  return dataPromise(
    apiFetch({ method: "POST", endpoint: `modality-scheduler/${orgId}/limits/templates`, data })
  )
}
export async function UpdateModalityLimitTemplate(orgId, data) {
  return dataPromise(
    apiFetch({ method: "PATCH", endpoint: `modality-scheduler/${orgId}/limits/templates`, data })
  )
}
export async function RemoveModalityLimitTemplate(orgId, data) {
  return dataPromise(
    apiFetch({ method: "POST", endpoint: `modality-scheduler/${orgId}/limits/templates/remove`, data })
  )
}
export async function UpsertModalityLimitOverride(orgId, data) {
  return dataPromise(
    apiFetch({ method: "PUT", endpoint: `modality-scheduler/${orgId}/limits/overrides`, data })
  )
}
export async function RemoveModalityLimitOverride(orgId, data) {
  return dataPromise(
    apiFetch({ method: "POST", endpoint: `modality-scheduler/${orgId}/limits/overrides/remove`, data })
  )
}

export async function GetStudyAudit(studyId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "studies/" + studyId + "/audit"
    })
  )
}
export async function GetPatientStudies(orgId, patientId) {
  return dataPromise(
    apiFetch({
      method: "GET",
      endpoint: "studies",
      params: { view: 'patient', org: orgId, PatientID: patientId }
    })
  )
}

// Integrations API
export async function GetIntegrations(orgId) {
  return dataPromise(apiFetch({ method: "GET", endpoint: `orgs/${orgId}/integrations` }))
}
export async function SaveIntegration(orgId, data) {
  return dataPromise(apiFetch({ method: "PUT", endpoint: `orgs/${orgId}/integrations`, data }))
}
export async function DeleteIntegration(orgId, type) {
  return dataPromise(apiFetch({ method: "DELETE", endpoint: `orgs/${orgId}/integrations/${type}` }))
}
export async function InitiateOAuth(orgId, type) {
  return dataPromise(apiFetch({ method: "POST", endpoint: `orgs/${orgId}/integrations/${type}/oauth` }))
}
export async function AuthenticateIntegration(orgId, type) {
  return dataPromise(apiFetch({ method: "POST", endpoint: `orgs/${orgId}/integrations/${type}/authenticate` }))
}